import type { Severity } from '@kirin/api-client/contracts/shared/severity';
import { SeverityBadge } from '@/components/policylist/components/SeverityBadge';

interface RiskBadgeProps {
  risk: Severity | string;
  /** Show icon before the label (default: false) */
  showIcon?: boolean;
  className?: string;
}

/**
 * Displays a color-coded badge for security scan risk levels.
 * This is a convenience wrapper around SeverityBadge for risk-level contexts.
 */
export function RiskBadge({
  risk,
  showIcon = false,
  className,
}: RiskBadgeProps) {
  return (
    <SeverityBadge riskLevel={risk} showIcon={showIcon} className={className} />
  );
}
